import { ReactNode } from "react";

export interface IFAQItem {
  id: string;
  title: string;
  isOpen?: boolean;
  isPirority: boolean;
  content: ReactNode;
}

export const faqData: IFAQItem[] = [
  {
    id: "1",
    title: "How does Music Porter work?",
    isPirority: true,
    content: (
      <span className="text-gray-500 dark:text-gray-400">
        Music Porter lets you transfer playlists from Spotify to Apple Music, YouTube Music, and more. We use song and album info to match your playlists and move them to your new platform—quick and easy.
      </span>
    ),
  },
  {
    id: "2",
    title: "Will transferring playlists delete my source playlists?",
    isPirority: true,
    content: (
      <span className="text-gray-500 dark:text-gray-400">
        Nope! We just copy your playlists, nothing gets deleted on your original music service. Your old playlists stay exactly the same.
      </span>
    ),
  },
  {
    id: "3",
    title: "Can I sync playlists automatically?",
    isPirority: true,
    content: (
      <span className="text-gray-500 dark:text-gray-400">
        Yes! Music Porter can automatically sync playlists between Spotify and YouTube Music (and more). Set it up once, and we’ll keep your playlists up to date across platforms.
      </span>
    ),
  },
  {
    id: "4",
    title: "Do you support private playlists?",
    isPirority: true,
    content: (
      <span className="text-gray-500 dark:text-gray-400">
        Yes, we do. You can transfer private playlists from Apple Music to Spotify and anywhere else, safely and easily.
      </span>
    ),
  },
  {
    id: "5",
    title: "What happens if a song isn’t available on the new platform?",
    isPirority: true,
    content: (
      <span className="text-gray-500 dark:text-gray-400">
        If a song isn’t available when you transfer playlists to Spotify or YouTube Music, we’ll skip it and let you know in the final report.
      </span>
    ),
  },
  {
    id: "6",
    title: "Is Music Porter secure?",
    isPirority: true,
    content: (
      <span className="text-gray-500 dark:text-gray-400">
        Yes! We never store your passwords, and all playlist transfers are encrypted for your safety.
      </span>
    ),
  },
  {
    id: "7",
    title: "How long does a transfer take?",
    isPirority: true,
    content: (
      <span className="text-gray-500 dark:text-gray-400">
        Most transfers take just a few minutes, even for big playlists.
      </span>
    ),
  },
  {
    id: "8",
    title: "Do I need a paid account to use Music Porter?",
    isPirority: true,
    content: (
      <span className="text-gray-500 dark:text-gray-400">
        We offer a free version for basic transfers. Advanced features like automatic sync may need a premium plan. You’ll also need a paid streaming account if your platform requires one.
      </span>
    ),
  },
];
